import { render } from "./LagScrewWithdrawal.vue?vue&type=template&id=0bf166b5"
import script from "./LagScrewWithdrawal.vue?vue&type=script&lang=js"
export * from "./LagScrewWithdrawal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__